// extracted by mini-css-extract-plugin
export default {"content":"DashboardEthnicityModal_content__wt57L"};